module.exports = __webpack_public_path__ + "img/trade1.11cbb94a.jpg";